import React, { Fragment, useState } from 'react';
import { Card, CardBody, CardHeader, Col } from 'reactstrap';
import { H5 } from '../../../../AbstractElements';
import Commen from './Commen';
const InitialValue = () => {
  const [val, setVal] = useState(53);
  return (
    <Fragment>
      <Col sm='12' md='6'>
        <Card>
          <CardHeader className='pb-0'>
            <H5 className='card-title'>{'Touchspin with initial Value'}</H5>
            <span>
              {'Add'} <code>{'data-bts-init-val="VALUE"'}</code>
              {' attribute attribute to set initial value for inputgroup.'}
            </span>
          </CardHeader>
          <CardBody>
            <Commen val={val} setVal={setVal} />
          </CardBody>
        </Card>
      </Col>
    </Fragment>
  );
};
export default InitialValue;
